import camelcaseKeys from 'camelcase-keys'

import { PageObjectButton } from '../page-objects/Button'

export class PageLink {
  constructor (params = {}) {
    const { button } = camelcaseKeys(params ? params : {})
    this.button = new PageObjectButton(button)
  }
}
